<template >
  <div name="assessment" class="inner">
     <div name="innertopbar" class="flex top-bar justify-between pl-2">
        <button class="filter-bar-button" @click="closeWindow()">
          <i class="fas fa-chevron-left " title="Close"></i> Back to {{ course.name }}
      </button>

      <button class="filter-bar-button" @click="closeWindow()">
          <i class="fas fa-times " title="Close"></i> Close
      </button>
    </div>

    <div class="ml-6 mb-6">
      <header class="flex justify-between mt-4 mb-6">
            <div class="flex mb-2">
                    <div class="mr-2 w-16 h-16 p-1 bg-purple-200 bg-opacity-25  rounded-full text-center "> 
                      <i class="fas fa-clipboard-list text-3xl text-base text-purple-800 opacity-75  pt-4" title="Overview"></i></div>
                    
                    <div class="pt-2"> 
                       <h3 class="text-xl font-semibold">Unit Assessment</h3>
                         <p class="text-sm pl-1 font-bold  text-purple-600 ">{{course.name}}</p>
                      <p class="text-xs pl-1 font-medium ">{{description}}</p>
                    </div>
                      
                    </div>



        <div>
          <button
            v-if="classSelected"
            @click="setAsSilver()"
            type="button"
            class="action-button not-round bg-blue-500 hover:bg-gray-400 text-xs 
              disabled:opacity-50 disabled:cursor-not-allowed"
  :disabled="!hasAccess"
            
          >
            Set all as Silver
          </button>
        </div>
      </header>

      <transition name="fade">
        <div class="loading" v-show="loading">
          <span class="fa fa-spinner fa-spin"></span> Loading
        </div>
      </transition>

      <transition name="fade">
        <div class="loading" v-show="isSaving">
          <span class="fa fa-spinner fa-spin"></span> Saving
        </div>
      </transition>

      <div v-if="errored" class="empty">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>

      <div v-if="hasAccess">
      <div v-if="componentLoaded"
        class="grid grid-cols-1 gap-4 w-full pr-6"
        v-bind:class="
          gradesList.length <= 3 ? 'md:grid-cols-3 ' : 'md:grid-cols-2'
        "
      >
        <div
          v-for="pupil in pupils"
          :key="pupil.identifer"
          class="content-center center"
        >
        <div class="bg-white p-1 rounded-xl border border-gray-300">
          <table
            class=" mb-3  w-full"
          >
            <thead class="font-bold text-blue-500">
              <td colspan="6">{{ pupil.name }}</td>
            </thead>
            <tbody>
              <tr class="bg-list-grey">
                <td colspan="2">&nbsp;</td>
                <td
                  v-for="grade in gradesList"
                  :key="grade.key"
                  class="text-xs text-center"
                >
                  {{ grade.value }}
                </td>
              </tr>
              <tr
                v-for="row in criteriaList"
                :key="row.key"
                class="odd:bg-gray-100"
              >
                <td class="text-xs">{{ row.value }}</td>
                <td
                  v-for="grade in gradeTitles"
                  :key="grade.value"
                  class="text-xs text-center"
                  @click="setAssessment(pupil, row, grade)"
                >
                  <button
                    v-if="grade.score === 0"
                    type="button"
                    class="border-none col-span-1 pl-1 pr-1 p-1 rounded text-xs font-medium text-gray-300 hover:text-blue-200 focus:outline-none"
                  >
                    <i class="pr-1 text-xl fas fa-times"></i>
                  </button>
                  <button
                    v-else
                    type="button"
                    class="px-1 p-1 rounded text-2xl lg:mr-1 xl:mr-5 icon font-bold focus:outline-none"
                    :class="setClass(pupil, row, grade)"
                    :style="setStyle(pupil, row, grade)"
                  ></button>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div></div>
      <div v-else>
        <UpgradeContent :area="'Assessment'"></UpgradeContent>
      </div>
    </div>
  </div>
</template>

  <script>
import { mapGetters } from "vuex";
import { AssessmentService } from "@/services/assessment.service";
import { calendarYearList } from "@/assets/js/utils";
import { assessmentMixin } from "@/mixins/assessmentMixin.js";
const innertopbar = () => import("@/components/InnerTopBar.vue");

const UpgradeContent = () => import("@/components/upgrade/UpgradeContent.vue");


export default {
  name: "assessment",
  mixins: [assessmentMixin],
  props: {
    course: Object,
    pupils: Array,
    classSelected: { type: Boolean, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    componentLoaded() {
      return this.loading == false;
    },
    hasAccess() {
       if (this.currentUser.isOnFree) {
            return this.currentAccess.assessmentAccess
       } else {
        return true
       }
    },
    description() {
      if (this.componentLoaded) {
        let pupilsIdentifiers = this.pupils.map((p) => p.identifier);

        let assesed = this.assessments.filter((a) => {
          return pupilsIdentifiers.includes(a.register_identifier);
        });

        return (
          assesed.length +
          " of " +
          this.pupils.length +
          " unit assessments for " +
          this.course.name +
          " " +
          "completed."
        );
      }
    },
  },
  data: function () {
    return {
      errored: false,
      loading: true,
      isSaving: false,
      assessments: [],
    };
  },
  created() {
       if (this.course == undefined) {
        this.closeWindow();
        return;
       }

    this.fetchCourseAssessment();
  },
  mounted() {},
  methods: {
    valueExists(pupil, criteria, grade) {
      let result = this.assessments.find(
        (a) => a.register_identifier === pupil.identifier
      );
      if (result == undefined) {
        return false;
      } else {
        switch (criteria.key) {
          case "criteria_1":
            if (result.criteria_1) {
              return result.criteria_1 === grade.score;
            }
            break;
          case "criteria_2":
            if (result.criteria_2) {
              return result.criteria_2 === grade.score;
            }
            break;
          case "criteria_3":
            if (result.criteria_3) {
              return result.criteria_3 === grade.score;
            }
            break;
          case "criteria_4":
            if (result.criteria_4) {
              return result.criteria_4 === grade.score;
            }
            break;
          case "criteria_5":
            if (result.criteria_5) {
              return result.criteria_5 === grade.score;
            }
            break;
          default:
            return false;
            break;
        }
      }
    },
    setClass(pupil, criteria, grade) {
      if (this.valueExists(pupil, criteria, grade)) {
        let icon = grade.legacy_key == "greater" ? "fa-star" : "fa-check-circle";
        return (
          "cursor-not-allowed" + " " + icon
        );
      } else {
        return (
          "text-gray-300 fa-plus-circle hover:opacity-50 hover:text-" + grade.text_color
        );
      }
    },
    setStyle(pupil, criteria, grade) {
      if (this.valueExists(pupil, criteria, grade)) {
        return (
          "color:#" + grade.color
        );
      }
    },
    fetchCourseAssessment() {
      AssessmentService.getByCourse(this.course.id)
        .then((response) => this.buildAssessments(response.data.data))
        .catch((err) => {
          console.log("Assessments " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildAssessments(data) {
      this.assessments = data;
    },
    setAsSilver() {
      this.$swal({
        title: "Are you sure you want to set all to Silver?",
        text: "This will change all data in current view!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, set as Silver!",
      }).then((result) => {
        if (result.value === true) {
          this.processSilver();
        }
      });
    },
    processSilver() {
      const vm = this;
      const silver = vm.gradesList.find((f) => f.key === "grade_2");
      if (silver != undefined) {
        vm.pupils.forEach(function (p) {
          var payload = vm.findAssessment(p);

          vm.criteriaList.forEach(function (c) {
            payload = vm.setAssessmentGrade(payload, c, silver);
          });

          vm.processAssessment(payload);
        });
      }
    },
    findAssessment(pupil) {
      var result = this.assessments.find(
        (a) => a.register_identifier === pupil.identifier
      );

      if (result == undefined) {
        return this.newAssessmentObject(pupil);
      } else {
        return result;
      }
    },
    newAssessmentObject(pupil) {
      let calendarYear = calendarYearList().find((y) => y.current === true);
      var payload = {
        course_id: this.course.id,
        register_identifier: pupil.identifier,
        calendar_schoolyear: calendarYear.value,
      };

      return payload;
    },
    setAssessmentGrade(payload, criteria, grade) {
      switch (criteria.key) {
        case "criteria_1":
          payload.criteria_1 = grade.score > 0 ? grade.score : 0;
          payload.performance = grade.legacy_key;
          break;
        case "criteria_2":
          payload.criteria_2 = grade.score > 0 ? grade.score : 0;
          payload.collaboration = grade.legacy_key;
          break;
        case "criteria_3":
          payload.criteria_3 = grade.score > 0 ? grade.score : 0;
          payload.competition = grade.legacy_key;
          break;
        case "criteria_4":
          payload.criteria_4 = grade.score > 0 ? grade.score : 0;
          break;
        case "criteria_5":
          payload.criteria_5 = grade.score > 0 ? grade.score : 0;
          break;
      }
      return payload;
    },
    setAssessment(pupil, criteria, grade) {
      var payload = this.findAssessment(pupil);
      payload = this.setAssessmentGrade(payload, criteria, grade);

      if (payload.identifier === undefined && grade.score === 0) {
        return;
      } else if (this.checkforDeletion(payload) === 0) {
         this.processDelete(payload);
      } else {
        this.processAssessment(payload);
      }
    },
    processDelete(object) {
      this.isSaving = true;
      AssessmentService.delete(object)
        .then((response) => {
          this.fetchCourseAssessment()
          this.completion(true)
      })
        .catch((err) => {
          this.failure(err);
        })
        .finally(() => (this.isSaving = false));
    },
    processAssessment(payload) {
      this.isSaving = true;

      if (payload.identifier != undefined) {
        AssessmentService.update(payload)
          .then((response) => {
            this.completion(true);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        let vm = this;
        AssessmentService.add(payload)
          .then((response) => {
            payload.identifier = response.data.identifier;
            vm.assessments.push(payload);
            this.completion(true);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    completion(val) {
      this.isSaving = false;
    },
    closeWindow() {
      this.$router.push({ name: "UnitView" });
    },
  },
    components: {
      UpgradeContent,
      innertopbar
    }
};
</script>

<style scoped>
</style>